import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-matselect',
	templateUrl:'./MatSelectPage.html',
	styles: [],
	styleUrls:['./MatSelectPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatSelectPage
{
	mdContent_263 = `\`\`\`java
import com.jwebmp.plugins.angular.material.select.MatSelect;
\`\`\``;
	mdContent_264 = `\`\`\`java
MatSelect()
\`\`\``;
	mdContent_265 = `\`\`\`java
MatSelect&lt;?&gt; select = new MatSelect&lt;&gt;();
select.setPlaceholder("Choose colours");
select.setMultiple(true);
select.addOption("Red", "red");
select.addOption("Green", "green");
select.addOption("Blue", "blue");
\`\`\``;
}
